import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import { PrintreportPage } from '../routing/routebank/reportorderbank/printreport';

/**
 * Generated class for the SuccsavedorderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-succsavedorder',
  templateUrl: 'succsavedorder.html',
})
export class SuccsavedorderPage {
  _navigate = 0;
  _points = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public modalCtrl: ModalController) {
    this._navigate = this.navParams.get('navigate') == undefined ? 0 : this.navParams.get('navigate');
    if (this._navigate == 1) {
      this._points = this.navParams.get('pts')
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SuccsavedorderPage');
  }

  doDone(_t) {
    if (_t == 'save') {
      this.printNalog(this.navParams.get('id'), this.navParams.get('pred'));
    }
    if (_t == 'cancel') {
      this.navCtrl.pop();
    }
    var cb = this.navParams.get('cb')
    cb();
  }
  printNalog(_u, _pred) {
    var _that = this
    let modal = this.modalCtrl.create(PrintreportPage, {
      did: _u, pred: _pred, cb: function () {
        // _that.loadData()
      }
    }, { cssClass: "modal-fullscreen2" });
    modal.present()
  }
  doNavigate() {
    this.navCtrl.pop();
    var cb = this.navParams.get('cb')
    cb();

    var _lon = 21.427379;
    var _lat = 41.998802;
    var _url = '/'
    var _ll = []
    for (var i = 0; i < this._points.length; i++) {
      _lon = parseFloat(this._points[i].lon)
      _lat = parseFloat(this._points[i].lat)
      _ll.push(_lat + ',' + _lon)
    }
    _url = "https://www.google.com/maps/dir/" + _ll.join('/') + "/data=!3m1!4b1!4m2!4m1!3e0"
    document.getElementById('a-toall').setAttribute("href", _url);
  }
}



// WEBPACK FOOTER //
// ./src/pages/succsavedorder/succsavedorder.ts